import { render, staticRenderFns } from "./SettingsTopBar.vue?vue&type=template&id=5f185aad&scoped=true"
import script from "./SettingsTopBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsTopBar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SettingsTopBar.vue?vue&type=style&index=0&id=5f185aad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f185aad",
  null
  
)

export default component.exports